// extracted by mini-css-extract-plugin
module.exports = {"section":"paraNos_section__SYWXJ","imageContainer":"paraNos_imageContainer__S_Nf0","content":"paraNos_content__cbkmA"};